import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, Container } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 5 }}>
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 80 }} />
        <Typography variant="h4" fontWeight="bold">
          404 - Page Not Found
        </Typography>
        <Typography variant="body1" color="textSecondary">
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Box display="flex" gap={2} mt={2}>
          <Button variant="outlined" onClick={() => navigate("/")}>
            Go Home
          </Button>
          <Button variant="contained" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
